import { render, staticRenderFns } from "./TextEditor.vue?vue&type=template&id=11dade95&scoped=true&"
import script from "./TextEditor.vue?vue&type=script&lang=ts&"
export * from "./TextEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TextEditor.vue?vue&type=style&index=0&id=11dade95&prod&lang=scss&"
import style1 from "./TextEditor.vue?vue&type=style&index=1&id=11dade95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dade95",
  null
  
)

export default component.exports